import NewLayoutEn from "../../../../src/components/newsLayoutEn.js";
import * as React from 'react';
export default {
  NewLayoutEn,
  React
};